"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionsList = void 0;
var React = require("react");
var styled_1 = require("../../styled");
var theme_1 = require("../../theme");
var OptionsList = function (_a) {
    var children = _a.children;
    return (React.createElement(OptionsListWrapper, null, children));
};
exports.OptionsList = OptionsList;
var OptionsListWrapper = styled_1.default.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  background: ", ";\n  border-radius: 4px;\n  width: 184px;\n  margin: 0px;\n  padding: 0px;\n  cursor: pointer;\n"], ["\n  display: flex;\n  flex-direction: column;\n  background: ", ";\n  border-radius: 4px;\n  width: 184px;\n  margin: 0px;\n  padding: 0px;\n  cursor: pointer;\n"])), theme_1.colors.white);
var templateObject_1;
//# sourceMappingURL=index.js.map